export const tl_data = {
    "breakfast_title": {
        "en":"Breakfast at A&W Canada - All day breakfast done right.",
        "fr":'Déjeuner A&W Canada - Vite fait, bien fait, toute la journée.'
    },
    "breakfast_description": {
        "en":"Explore our breakfast menu with delicious options like bacon, eggs, hash browns, pancakes, wraps, the Beyond Meat Sausage & Egger and more.",
        "fr":"Explorez notre menu déjeuner rempli de délicieuses options comme du bacon, des œufs, des patates hachées brunes, des crêpes, le Chef-d’œuf™ avec saucisse Beyond Meat et encore plus."
    },
    "burgers_title": {
        "en":"Burgers at A&W Canada -  We make Canada’s best tasting burger.",
        "fr":"Burgers chez A&W Canada - Des vrais bons burgers comme on les aime."
    },
    "burgers_description": {
        "en":"Explore the Mama Burger, Papa Burger, Teen Burger, Uncle Burger, Beyond Meat Burger and more.",
        "fr":"Découvrez le Mama Burger, le Papa Burger, le Teen Burger, l’Oncle Burger, le Burger Beyond Meat, et encore plus."
    },
    "chicken_title": {
        "en":"Chicken at A&W Canada - Burgers and strips made from 100% chicken.",
        "fr":"Poulet chez A&W Canada - Des burgers et des languettes préparés avec de la poitrine de poulet à 100 %."
    },
    "chicken_description": {
        "en":"From the BLT Chicken Burger to the Chicken Grill Deluxe, all of our chicken products are raised without the use of antibiotics.",
        "fr":"Du Burger au poulet BLT à notre Grill-O-Poulet™, nous servons uniquement du poulet de grain élevé sans antibiotiques."
    },
    "chubby_chicken_title": {
        "en":"",
        "fr":''
    },
    "chubby_chicken_description": {
        "en":"",
        "fr":""
    },
    "drinks_title": {
        "en":"Drinks at A&W Canada - Delicious hot and cold beverages.",
        "fr":"Boissons chez A&W Canada - De délicieuses boissons, chaudes ou froides."
    },
    "drinks_description": {
        "en":"From fresh-made coffee to frosted mugs of refreshing Root Beer, we’ve got everything you need to quench your thirst.",
        "fr":"Qu’il s’agisse de notre café fraîchement préparé ou de nos bocks de Root Beer givrés, on a tout ce qu’il faut pour étancher votre soif."
    },
    "sides_title": {
        "en":"Sides at A&W Canada - Up your meal game with our delicious sides.",
        "fr":"À-côtés chez A&W Canada - Faites-vous plaisir avec un petit à-côté."
    },
    "sides_description": {
        "en":"No meal is complete without one of our tasty sides. Add poutine, onion rings, sweet potato or thick cut fries to your burger today.",
        "fr":"a&w Canada, menu, à-côtés, accompagnements,rondelles d'oignons, frites, frites de patates douces, chausson aux pommes, suçon, nourriture, nutrition, allergènes, calories"
    },
    "kidspack_title": {
        "en":"Kids' Pack at A&W Canada - You'll want what the kids are having.",
        "fr":"Régal pour enfants chez A&W Canada - Vous voudrez ce que les enfants prennent."    
    },
    "kidspack_description": {
        "en":"Explore our menu and find nutritional and allergen information.",
        "fr":"Explorez notre menu et découvrez de l'information nutritionnelle et sur les allergènes."
    },
    "brewbar_title": {
        "en":"Brew Bar at A&W Canada - Delicious hot and cold beverages.",
        "fr":'Le Brew Bar chez A&W Canada - De délicieuses boissons, chaudes ou froides.'
    },
    "brewbar_description": {
        "en":"Explore our menu and find nutritional and allergen information.",
        "fr":"Explorez notre menu et découvrez de l'information nutritionnelle et sur les allergènes."
    },
    "pret_title": {
        "en":"Pret at A&W Canada - Delicious hot and cold beverages.",
        "fr":'Pret chez A&W Canada - De délicieuses boissons, chaudes ou froides.'
    },
    "pret_description": {
        "en":"Explore our menu and find nutritional and allergen information.",
        "fr":"Explorez notre menu et découvrez de l'information nutritionnelle et sur les allergènes."
    },
    "featured_title": {
        "en":"Featured at A&W Canada",
        "fr":'En vedette chez A&W Canada'
    },
    "featured_description": {
        "en":"Explore our menu and find nutritional and allergen information.",
        "fr":"Explorez notre menu et découvrez de l'information nutritionnelle et sur les allergènes."
    }


  }